<template lang="pug">
  .truncated-text
    p {{ visibleText }}
      template(v-if="hasExtra")
        span(:class="{ 'as-block': !inline }" @click="toggleText" v-html="controlText").reveal-text.color-mr-purple.underline.clickable

</template>

<script>
  export default {
    name: "TruncatedText",

    props: {
      text: {
        type: String,
        required: true
      },

      visibleCharacters: {
        type: Number,
        required:false,
        default: 200
      },

      inline: {
        type: Boolean,
        required: false,
        default: true
      },

      showMore: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    data() {
      return {
        open: false
      };
    },

    computed: {
      hasExtra() {
        return this.visibleCharacters < this.text.length;
      },

      visibleText() {
        let visible = this.text;

        if (this.hasExtra && !this.open){
          visible = this.text.substring(0, this.visibleCharacters).trim() + '...';
        }

        return visible;
      },

      controlText() {
        if (!this.showMore) {
          return;
        }
        return this.open ? 'Show less' : 'Show more';
      }
    },

    methods: {
      toggleText() {
        this.open = !this.open;
      }
    }
  };
</script>

<style scoped lang="stylus">
  .truncated-text
    .reveal-text
      padding-left 0.3em

      &.as-block
        padding-left 0
        display block
</style>